import { Clause } from "./clauseType";

export const clauseinitial: Clause = {
    clause: "",
}